import { APP_COLORS } from '../../../helpers/constants'

export const saltoSpaceDropdownStyles = (hasError) => ({
  control: () => ({
    display: 'flex',
    minHeight: '5vh',
    backgroundColor: hasError ? APP_COLORS.red100 : APP_COLORS.grey200,
    justifyContent: 'space-between',
    border: hasError ? `1px solid ${APP_COLORS.red200}` : `1px solid ${APP_COLORS.grey800}`,
    borderRadius: '5px',
    alignItems: 'center',
    cursor: 'pointer',
    overflow: 'hidden',
  }),
  option: (_, state) => ({
    backgroundColor: state.isSelected ? APP_COLORS.grey300 : APP_COLORS.baseWhite,
    flexDirection: 'row',
    display: 'flex',
    height: '5vh',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingLeft: '1vw',
    fontSize: '14px',
    cursor: 'pointer',
    borderBottom: `1px solid ${APP_COLORS.grey300}`,
  }),
  valueContainer: (styles) => ({
    ...styles,
    maxHeight: '10vh',
    overflowY: 'auto',
  }),
})

export const getSelectedItemsValue = (selectedIds, itemsArray) => {
  return selectedIds
    ? selectedIds.map((id) => itemsArray.find((item) => item.saltoId === id))
    : null
}

export const getAccessText = (t, selectedGroupsNames, selectedAccessLevelsNames) => {
  if (selectedGroupsNames.length === 0 && selectedAccessLevelsNames.length === 0) {
    return ' '
  }

  const groupsText = selectedGroupsNames.join(', ')
  const accessLevelsText =
    selectedAccessLevelsNames.length > 0
      ? ` ${t('management-users:integrations.andConnector')} ${selectedAccessLevelsNames.join(', ')}`
      : ''

  return ` ${t('management-users:integrations.toConnector')} ${groupsText}${accessLevelsText} `
}

export const getConfirmationText = (t, managementUserData, values) => {
  const {
    user: { firstName, lastName },
    jobTitle,
  } = managementUserData

  const accessText = getAccessText(t, values.selectedGroupsNames, values.selectedAccessLevelsNames)

  return t('management-users:integrations.confirmAccessBody', {
    accessText,
    firstName,
    lastName,
    jobTitleSuffix: jobTitle ? `, ${jobTitle}` : '',
  })
}

export const getRoles = (t) => [
  {
    id: 0,
    text: t('management-users:roleLabels.allRoles'),
    name: 'AllRoles',
    selectAll: true,
  },
  {
    id: 1,
    text: t('management-users:roleLabels.propertyManager'),
    name: 'PropertyManager',
  },
  {
    id: 2,
    text: t('management-users:roleLabels.frontDesk'),
    name: 'ShiftManager',
  },
  {
    id: 3,
    text: t('management-users:roleLabels.maintenance'),
    name: 'Staff',
  },
  {
    id: 4,
    text: t('management-users:roleLabels.valet'),
    name: 'Valet',
  },
  {
    id: 5,
    text: t('management-users:roleLabels.parkingStaff'),
    name: 'ParkingStaff',
  },
]
